import {Accept} from 'react-dropzone';

export const UPLOAD_MAX_MB = 100;
export const UPLOAD_MAX_BYTES = UPLOAD_MAX_MB * 1024 * 1024;

export const UPLOAD_ACCEPT: Accept = {
  'application/msword': ['.doc', '.dot'],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.ms-powerpoint': ['.ppt'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],
  'application/vnd.oasis.opendocument.text': ['.odt'],
  'application/vnd.oasis.opendocument.spreadsheet': ['.ods'],
  'application/vnd.oasis.opendocument.presentation': ['.odp'],
  'application/epub+zip': ['.epub'],
  'application/zip': ['.zip'],
  'text/rtf': ['.rtf'],
  'application/pdf': ['.pdf'],
  'text/csv': ['.csv'],
  'text/tab-separated-values': ['.tsv'],
  'text/markdown': ['.md'],
  'application/json': ['.json'],
  'application/yaml': ['.yaml', '.yml'],
  'application/xml': ['.xml'],
  'text/plain': ['.txt']
};

export const UPLOAD_IMG_ACCEPT: Accept = {
  'image/jpeg': [],
  'image/png': [],
  'image/gif': [],
  'image/webp': [],
  'image/avif': []
};
